import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=4c7db8a7&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style0 from "./Footer.vue?vue&type=style&index=0&id=4c7db8a7&prod&lang=scss&scoped=true"
import style1 from "./Footer.vue?vue&type=style&index=1&id=4c7db8a7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_6554cb098e537a9b8e01f1854c0c52c1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7db8a7",
  null
  
)

export default component.exports